export const POWER_MIN_INTERVAL: number = 1200;
export const POWER_FACTOR_MIN_INTERVAL: number = 1200;
export const DEFAULT_NOTIFICATION_REFETCH_INTERVAL_IN_MS: number = 300000;
